export default "__VITE_ASSET__DZhpudr___"